/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { NgClass, NgStyle } from '@angular/common';
import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Moment } from 'moment';
import { DateTimeHelperService } from '../date-time-helper/date-time-helper.service';


@Component({
  selector: 'hb-datepicker-control',
  templateUrl: './datepicker-control.component.html',
  styleUrls: ['./datepicker-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: DatepickerControlComponent,
      multi: true,
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ],
})
export class DatepickerControlComponent implements ControlValueAccessor {
  @Input() public controlId: string;
  @Input() public isDisabled: boolean;
  @Input() public placeholderText: string;
  @Input() public endDate: Date;
  @Input() public orientation: string;
  @Input() public autocomplete: string = 'off';

  @Input() public inputClass: string;
  @Input() public showClearButton: boolean = false;
  @Input() public ngClass: NgClass;
  @Input() public ngStyle: NgStyle;

  @Output() public onDateChange = new EventEmitter<string>();

  public value: Moment;

  constructor(
    private dateTimeHelper: DateTimeHelperService,
    @Inject(MAT_DATE_FORMATS) public data: typeof MAT_MOMENT_DATE_FORMATS
  ) {
    data.parse.dateInput = `${this.dateTimeHelper.dateFormat}`;
    data.display.dateInput = `${this.dateTimeHelper.dateFormat}`;
  }

  public updateDate(e: MatDatepickerInputEvent<Moment>) {
    this.value = (e.value);
    this.onChange(e.value);
    this.onDateChange.emit(e.value.toISOString());
  }


  public writeValue(value: string): void {

    if (value && this.dateTimeHelper.isValidDateString(value)) {
      this.value = (this.dateTimeHelper.stringToMoment(value));
      this.onDateChange.emit(value);
    } else {
      this.value = (null);
    }
  }

  public onChange = (_: any): void => { };

  public onTouched = (): void => { };

  public registerOnChange(fn: (_: any) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public clearDateTimeControl(): void {
    this.value = (null);
    this.onChange(null);
  }
}
